// extracted by mini-css-extract-plugin
export default {"mainTitle":"Header_mainTitle__B9pgg","badge":"Header_badge__kJdA3","paragraph":"Header_paragraph__iQARm"};